export default "__VITE_ASSET__fd734b4c__"